import React from 'react'

export default ({ id, name, type, label, placeholder, items, onChange, ...props }) => (
  <div className="field">
    <label htmlFor="email">{label}</label>
    <select 
      id={id || name} 
      {...props}
      name={name} 
      className="on"
      type={type || 'text'} 
      placeholder={label}
      onChange={e => onChange(e.target.value)}
    >
      {items.map(item => <option key={item.value} value={item.value}>{item.label}</option>)}
    </select>
  </div>
)


// WEBPACK FOOTER //
// ./src/views/shared/select.js